import React, { useEffect, useState } from 'react'
import { Badge, Drawer, Dropdown, Menu, Tabs } from "antd"
import pluralize from 'pluralize'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { Route, Switch, Link, useHistory, useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'

import EditLocum from '../modals/locum'

const { TabPane } = Tabs

let statuses = ['All', 'Pending', 'Seen', 'Approved', 'Rejected']

const Department = () => {
    const [rType, setType] = useState()

    const [
        { loading, error, fetch },
        { list },
        { navigate, Paginate }
    ] = useListData('locumRequestsByAuthorization', {
        status: rType?.value ?? 'All'
    }, { notify: true, manual: true }, 'requests')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    useEffect(() => {
        refresh()
    }, [rType])

    return (
        <div className="overflow-x-auto">
                <span className="flex justify-between items-center mb-2">
                    <Select
                        value={rType}
                        onChange={ setType }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={ statuses.map(cls => ({ label: cls, value: cls })) }
                        placeholder="Status" />
                </span>
                <Receive
                    error={error}
                    loading={loading}
                    progress>
                    {
                        list.length > 0 ?   
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Requested For</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Status</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Department</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Date</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        list.map((request, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">{key + 1}.</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ request?.requestedFor }</div>
                                                </td>
                                                <td className="p-2">
                                                    <p className={ `text-${ request.status === 'Pending' ? 'gray' : request.status === 'Approved' ? 'green': request.status === 'Rejected' ? 'red' : 'yellow' }-500 my-0` }>{ request.status }</p>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{ request.department }</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-left">{ stringifyDate(request.date) }</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                <Menu.Item onClick={ () => null }>View</Menu.Item>
                                                                {/* {
                                                                    !request.seen &&
                                                                    <>
                                                                        <Menu.Item onClick={ () => {
                                                                            setSelected(request)
                                                                            locToggle()
                                                                        } }>Edit</Menu.Item>
                                                                        <Menu.Item onClick={ () => null }>Delete</Menu.Item>
                                                                    </>
                                                                } */}
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        :
                            <div className="flex items-center justify-center h-28">
                                <h2>No requests have been sent yet</h2>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
    )
}

const Locum = ({ path, department, onPerform  }) => {
    const [key, setKey] = useState("0")
    const [rType, setType] = useState()
    const [selected, setSelected] = useState()

    const { id } = useParams()

    const history = useHistory()

    const { user } = useSelector(state => state.application)

    const [visible, toggle] = useToggle(true)
    const [locVisible, locToggle] = useToggle()

    const close = () => {
        toggle()
        setTimeout(() => history.push(path), 300)
    }

    const [
        { loading, error, fetch },
        { list: myRequests },
        { navigate, Paginate }
    ] = useListData('myLocumRequests', {
        status: rType?.value ?? 'All'
    }, { notify: true, manual: true }, 'requests')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    useEffect(() => {
        refresh()
    }, [rType, key])

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width={800}>
            {
                locVisible &&
                <EditLocum
                    onPerform={ refresh }
                    visible={ locVisible }
                    toggle={ locToggle }
                    request={ selected } />
            }
            <p className="font-extrabold text-3xl mb-0">Locum Requests</p>
            <Tabs className="min-h-full" activeKey={ key } onChange={ setKey }>
                <TabPane key="0" tab="My Requests">
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center mb-2">
                            <Select
                                value={rType}
                                onChange={ setType }
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ statuses.map(cls => ({ label: cls, value: cls })) }
                                placeholder="Status" />
                            <button onClick={ locToggle } className="btn m-0 hisani-btn-green-light text-white">
                                <span className="hidden xs:block mr-2">New Request</span>
                            </button>
                        </span>
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                myRequests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested For</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Department</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                myRequests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ request?.requestedFor }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <p className={ `text-${ request.status === 'Pending' ? 'gray' : request.status === 'Approved' ? 'green': request.status === 'Rejected' ? 'red' : 'yellow' }-500 my-0` }>{ request.status }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request.department }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => null }>View</Menu.Item>
                                                                        {
                                                                            !request.seen &&
                                                                            <>
                                                                                <Menu.Item onClick={ () => {
                                                                                    setSelected(request)
                                                                                    locToggle()
                                                                                } }>Edit</Menu.Item>
                                                                                <Menu.Item onClick={ () => null }>Delete</Menu.Item>
                                                                            </>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </TabPane>
                {
                    user.stations.some(station => station.name === 'locum') || user.issuperuser ?
                        <TabPane key="1" tab="Department Requests">
                            <Department />
                        </TabPane>
                    : null
                }
            </Tabs>
            {/* <Switch>
                <Route path={ `${path}/locum/new/:index` }>
                    <PatientRequest 
                        patients={ ptns } 
                        path={ path } 
                        onPerform={ saveEntries } />
                </Route>
                <Route path={ `${path}/requests/:id` }>
                    <SingleRequest path={ path } />
                </Route>
                <Route path="/app/store/:id/requests/:rq/issue">
                    <IssueSingleRequest onPerform={ onClose } />
                </Route>
            </Switch> */}
        </Drawer>
    )
}

export default Locum